import { render, staticRenderFns } from "./TypePie.vue?vue&type=template&id=f7a3e664"
import script from "./TypePie.vue?vue&type=script&lang=js"
export * from "./TypePie.vue?vue&type=script&lang=js"
import style0 from "./TypePie.vue?vue&type=style&index=0&id=f7a3e664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports